angular.module('trainerWebApp.services').service("uploadSvc", ['$resource', 'errorHandler', function ($resource, errorHandler) {
  var s3Resource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/contentfile/s3');
  var gsCourse = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/getting-started/course');
  var convert = $resource('/TrainerGS/FinishUploadStartConversion');

  this.getS3UploadPath = function getS3UploadPath(params) {
    return s3Resource.save(params, angular.noop, errorHandler.defaultServerErrorHandler()).$promise;
  };

  this.getEmptyCourse = function getEmptyCourse() {
    return gsCourse.save(angular.noop, errorHandler.defaultServerErrorHandler()).$promise;
  };

  this.startConvert = function startConvert(params) {
    return convert.save(params, angular.noop, errorHandler.defaultServerErrorHandler()).$promise;
  };
}]);
